<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>I</i> <i>would like to acknowledge</i></p>
<p class="ded1">C<span class="smallcaps">ARMEN</span> L<span class="smallcaps">A</span>V<span class="smallcaps">IA</span></p>
<p class="ded1">S<span class="smallcaps">USAN</span> A<span class="smallcaps">LLISON</span></p>
<p class="ded1">I<span class="smallcaps">VY</span> F<span class="smallcaps">ISCHER</span> S<span class="smallcaps">TONE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4b197a44